// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3k1Rc","footer":"ModalError_footer__Ne3P7"};